export default __webpack_public_path__ + "static/media/warning--bicycles-crossing--g4.bc459af3.png";